/**
 * @generated SignedSource<<47865c827d68fd0893028653b7e0f53e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskDerivedTasksDialog_derivedTasksQuery$variables = {
  id: string;
  kind?: string | null;
};
export type TaskDerivedTasksDialog_derivedTasksQuery$data = {
  readonly task: {
    readonly derivedTasks: ReadonlyArray<{
      readonly id: string;
      readonly sequence: number;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"TaskStatusLabel_task">;
    }>;
    readonly id: string;
  };
};
export type TaskDerivedTasksDialog_derivedTasksQuery = {
  response: TaskDerivedTasksDialog_derivedTasksQuery$data;
  variables: TaskDerivedTasksDialog_derivedTasksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kind"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskDerivedTasksDialog_derivedTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "derivedTasks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TaskStatusLabel_task"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskDerivedTasksDialog_derivedTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "derivedTasks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b1bff8332a5c5bbe5a4c71677ee8e2f2",
    "id": null,
    "metadata": {},
    "name": "TaskDerivedTasksDialog_derivedTasksQuery",
    "operationKind": "query",
    "text": "query TaskDerivedTasksDialog_derivedTasksQuery(\n  $id: ID!\n  $kind: String\n) {\n  task(id: $id) {\n    id\n    derivedTasks(kind: $kind) {\n      id\n      sequence\n      title\n      ...TaskStatusLabel_task\n    }\n  }\n}\n\nfragment TaskStatusLabel_task on Task {\n  status\n}\n"
  }
};
})();

(node as any).hash = "9390611d1b00eb648cad9f4cf96c395a";

export default node;
